import React from 'react';
import { mockData } from '../data/mockData';
import { Star } from 'lucide-react';

const Testimonials = () => {
  return (
    <section id="testimonials" className="relative py-32 bg-black">
      <div className="max-w-[1400px] mx-auto px-[7.6923%]">
        {/* Section Header */}
        <div className="text-center mb-20">
          <h2 className="display-large text-white mb-6">
            What Our <span className="text-[#00FFD1]">Clients Say</span>
          </h2>
          <p className="body-large text-white/85 max-w-3xl mx-auto">
            Trusted by businesses across Manipal, Udupi, and Karnataka for delivering 
            exceptional virtual tour experiences.
          </p>
        </div>

        {/* Testimonials Grid */}
        <div className="grid md:grid-cols-2 gap-8">
          {mockData.testimonials.map((testimonial) => (
            <div
              key={testimonial.id}
              className="p-8 bg-white/5 backdrop-blur-sm border border-white/10 hover:border-[#00FFD1]/50 hover:bg-white/10 transition-all duration-400"
            >
              {/* Rating Stars */}
              <div className="flex gap-1 mb-6">
                {[...Array(testimonial.rating)].map((_, i) => (
                  <Star key={i} className="w-5 h-5 text-[#00FFD1] fill-[#00FFD1]" />
                ))}
              </div>

              {/* Testimonial Text */}
              <p className="body-medium text-white/85 mb-6 italic">
                "{testimonial.text}"
              </p>

              {/* Author Info */}
              <div className="flex items-center gap-4 pt-6 border-t border-white/10">
                <div className="w-12 h-12 bg-[#00FFD1]/20 flex items-center justify-center text-[#00FFD1] font-semibold text-lg">
                  {testimonial.avatar}
                </div>
                <div>
                  <h4 className="heading-3 text-white">{testimonial.name}</h4>
                  <p className="body-small text-white/60">{testimonial.business}</p>
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* Stats Section */}
        <div className="grid grid-cols-2 md:grid-cols-4 gap-8 mt-20">
          <div className="text-center p-8 bg-white/5 backdrop-blur-sm border border-white/10">
            <div className="display-medium text-[#00FFD1] mb-2">
              {mockData.stats.businessesServed}+
            </div>
            <div className="body-small text-white/70">Businesses Served</div>
          </div>
          <div className="text-center p-8 bg-white/5 backdrop-blur-sm border border-white/10">
            <div className="display-medium text-[#00FFD1] mb-2">
              {mockData.stats.toursCreated}+
            </div>
            <div className="body-small text-white/70">Tours Created</div>
          </div>
          <div className="text-center p-8 bg-white/5 backdrop-blur-sm border border-white/10">
            <div className="display-medium text-[#00FFD1] mb-2">
              {mockData.stats.citiesCovered}+
            </div>
            <div className="body-small text-white/70">Cities Covered</div>
          </div>
          <div className="text-center p-8 bg-white/5 backdrop-blur-sm border border-white/10">
            <div className="display-medium text-[#00FFD1] mb-2">
              {mockData.stats.satisfiedClients}+
            </div>
            <div className="body-small text-white/70">Happy Clients</div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Testimonials;
